import { Card, CardContent, Typography } from "@mui/material"
import { Examination } from "graphql/types"
import { useStoreState } from "hooks/storeHooks"
import { useParams } from "react-router"

type ProjectInfosProps = {
  examination: Examination
}

export const ProjectInfos = (props: ProjectInfosProps) => {
  const { projectID } = useParams()
  const projectsState = useStoreState((state) => state.projects)
  const leads = useStoreState((state) => state.leads)
  const customers = useStoreState((state) => state.customers)

  const project = projectsState.find((item) => item?.id === projectID)

  const { examination } = props

  const getBusinessCustomerName = (opportunityID: string) => {
    const lead = leads.find((lead) => lead.opportunityID === opportunityID)
    if (lead) {
      const customer = customers.find((customer) => customer.customerID === lead.businessAccount)
      if (customer) {
        return customer.customerName
      }
    }
    return ""
  }

  return (
    <Card>
      <CardContent sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div>
          <Typography variant="h3" sx={{ display: "flex", alignItems: "baseline", gap: 2 }}>
            <span style={{ color: "#666", fontSize: "0.85em" }}>
              {project?.lead.opportunityID}
            </span>
            {getBusinessCustomerName(project?.lead.opportunityID || "")}
          </Typography>
          <Typography variant="body2">
            Prüfverfahren: {examination.name} nach {examination.norm?.name || "Keine Norm"}
          </Typography>
        </div>
      </CardContent>
    </Card>
  )
}
